"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGA4Items = void 0;
const services_epoq_1 = require("./services.epoq");
const services_ga4ItemList_1 = __importDefault(require("./services.ga4ItemList"));
const getGA4Items = (items, listId) => {
    const ga4Items = [];
    const epoqTestGroup = (0, services_epoq_1.getEpoqTestGroup)();
    const storedItems = services_ga4ItemList_1.default.getItems();
    items.forEach((item, index) => {
        var _a;
        const categories = item.categories[0].split("/");
        const itemListId = listId !== null && listId !== void 0 ? listId : (_a = storedItems.find((_item) => _item.id === item.style)) === null || _a === void 0 ? void 0 : _a.listId;
        const product = {
            index,
            item_id: item.style,
            item_name: item.name,
            item_brand: item.label,
            vendorCode: item.vendorCode,
            vendorName: item.vendorName,
            price: Number(item.price),
            quantity: Number(item.quantity),
            ...(categories[0] && { item_category: categories[0] }),
            ...(categories[1] && { item_category2: categories[1] }),
            ...(categories[2] && { item_category3: categories[2] }),
            ...(categories[3] && { item_category4: categories[3] }),
            ...(categories[4] && { item_category5: categories[4] }),
            ...(item.variant && { item_variant: item.variant }),
            ...(item.msrp && item.price && { discount: Number(item.msrp) - Number(item.price) }),
            ...(itemListId && { item_list_id: itemListId }),
            ...(epoqTestGroup && { epoqPLS_ABTest: epoqTestGroup }),
        };
        ga4Items.push(product);
    });
    return ga4Items;
};
exports.getGA4Items = getGA4Items;
